import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../shared/components/button/Button';
import LoadingSpinner from '../../../shared/components/UIElements/LoadingSpinner';
import { useSignupScreen3 } from './useSignupScreen3';

interface SignupScreen3Props {
  handleContinue: (dataObj: any) => void;
  error: string | undefined;
}

export function SignupScreen3({ handleContinue, error }: SignupScreen3Props) {
  const { t } = useTranslation();

  const {
    termsAccepted,
    isLoading,
    scrollableRef,
    buttonTriggerRef,
    handleContinue: handleContinueClick,
    handleTermsAcceptance,
    handleScroll,
    scroll,
  } = useSignupScreen3({ handleContinue });

  return (
    <>
      <h1>{t('R034')}</h1>
      <div className="terms-conditions-subtitle-container">
        <p className="terms-conditions-subtitle">
          {t('terms.conditions.subtitle.new')}
          {t('terms.conditions.subtitle.second')}{' '}
          <a
            href="https://support.championhealth.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
            className="terms-conditions-subtitle-link"
            aria-label={`${t('terms.conditions.subtitle.link')} (opens in new window)`}
          >
            {t('terms.conditions.subtitle.link')}
          </a>
        </p>
      </div>
      <div className="tandc">
        <div
          ref={scrollableRef}
          id="scrollable"
          className="tandc_container"
          onScroll={handleScroll}
          tabIndex={0}
          role="region"
          aria-label="Terms and conditions content"
        >
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035v') }} />
            <span> </span>
            <a
              href="https://www.championhealth.co.uk/legals/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Terms of Service (opens in new window)"
            >
              {t('R035aa')}
            </a>
            .
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035a') }} />
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035b') }} />
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035c') }} />
          </p>
          <p ref={buttonTriggerRef} id="button_trigger">
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035d') }} />
            <span> </span>{' '}
            <a
              href="https://www.championhealth.co.uk/legals/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Privacy Policy (opens in new window)"
            >
              {t('R035u')}
            </a>{' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035ab') }} />{' '}
            <a
              href="https://support.championhealth.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Terms of Service (opens in new window)"
            >
              {t('R035aa')}
            </a>
            .
          </p>
          <p>
            <b>{t('R035e')}</b>
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035f') }} />
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035g') }} />
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035h') }} />
          </p>
          <p>
            <b>{t('R035i')}</b>
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035j') }} />
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035k') }} />
            <a
              href="https://support.championhealth.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Support contact (opens in new window)"
            >
              {t('R035ac')}
            </a>
            .
          </p>
          <p>
            <b>{t('R035l')}</b>
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035m') }} />
          </p>
          <p style={{ paddingLeft: '10px' }}>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035n') }} />
          </p>
          <p style={{ paddingLeft: '10px' }}>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035n1') }} />
          </p>
          <p style={{ paddingLeft: '10px' }}>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035o') }} />
          </p>
          <p style={{ paddingLeft: '10px' }}>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035o1') }} />
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035ad') }} />{' '}
            <a
              href="https://www.championhealth.co.uk/legals/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Privacy Policy (opens in new window)"
            >
              {t('R035u')}
            </a>{' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035ae') }} />
          </p>
          <p>
            <b>{t('R035r')}</b>
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035s') }} />
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035t') }} />
          </p>
          <p>
            <b>{t('R035q')}</b>
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035w') }} />
          </p>
          <p>
            <b>{t('R035x')}</b>
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035y') }} />
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035z') }} />
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035af') }} />
          </p>
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035ag') }} />
          </p>{' '}
          <p>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('R035ah') }} />
          </p>
        </div>
      </div>

      <div className="terms-acceptance-container">
        <label
          className="terms-checkbox-label"
          htmlFor="terms-acceptance"
          data-testid="signup-terms-acceptance-label"
        >
          <input
            type="checkbox"
            id="terms-acceptance"
            checked={termsAccepted}
            onChange={handleTermsAcceptance}
            className="terms-checkbox"
            aria-describedby="terms-description"
            data-testid="signup-terms-acceptance-checkbox"
          />
          <span className="terms-checkbox-text">{t('terms.conditions.acceptance.text')}</span>
        </label>
        <p id="terms-description" className="terms-description">
          {t('terms.conditions.acceptance.description')}
        </p>
      </div>
      {isLoading && <LoadingSpinner asOverlay />}
      {error && (
        <p className="login_error" role="alert">
          {' '}
          <FontAwesomeIcon icon={faTriangleExclamation} className="icon" />
          <span dangerouslySetInnerHTML={{ __html: error }} />
        </p>
      )}
      {!isLoading && (
        <Button
          onClick={handleContinueClick}
          id="continue"
          className={termsAccepted ? 'accepted' : 'declined'}
          isDisabled={!termsAccepted}
          aria-describedby={!termsAccepted ? 'terms-description' : undefined}
          dataTestId="signup-continue-button"
        >
          {t('R053')}
        </Button>
      )}
    </>
  );
}
